import i18n from 'i18next'
import ICU from 'i18next-icu'
import { initReactI18next } from 'react-i18next'

import ENGLISH from './translations/en.json'
import GERMAN from './translations/de.json'
import JAPANESE from './translations/ja.json'
import FRENCH from './translations/fr.json'

// import AG_GRID_LOCALE_DE from '@localize/localization-manage-ui/de/locale.aggrid.json'
// import AG_GRID_LOCALE_EN from '@localize/localization-manage-ui/en/locale.aggrid.json'
// import AG_GRID_LOCALE_JA from '@localize/localization-manage-ui/ja/locale.aggrid.json'
// import AG_GRID_LOCALE_FR from '@localize/localization-manage-ui/fr/locale.aggrid.json'

const defaultLng = 'en'
const supportedLngs = ['en', 'de', 'ja', 'fr']

export const _T = i18n.t.bind(i18n) as (key: string) => string

export function getUserLanguage(): string {
  const navLang = navigator.language.split('-', 1)[0]
  return supportedLngs.includes(navLang) ? navLang : defaultLng // "de" -- change to hardcoded in order to test
}

export function getGridLocale(): Record<string, string> { // to be used in ag-grid prop "localeText"
  // const userLng = getUserLanguage()
  // switch (userLng) {
  //   case 'en':
  //     return AG_GRID_LOCALE_EN
  //   case 'de':
  //     return AG_GRID_LOCALE_DE
  //   case 'ja':
  //     return AG_GRID_LOCALE_JA
  //   case 'fr':
  //     return AG_GRID_LOCALE_FR
  //   default:
  //     return AG_GRID_LOCALE_EN
  // }
  console.error('sparky framework no longer provide getGridLocale for ag-grid')
  return {}
}

i18n
  .use(ICU)
  .use(initReactI18next)
  .init({
    lng: getUserLanguage(),
    fallbackLng: defaultLng,
    supportedLngs: supportedLngs,
    nsSeparator: ';;;', // dot and semicolon are meaningfull keys for i18next as key and namespace separator
    keySeparator: ':::', // we replace them with non used characters
    interpolation: {
      escapeValue: false
    },
    resources: { // "lng" : { translation: { key: value}}
      'en': {
        translation: ENGLISH,
      },
      'de': {
        translation: GERMAN
      },
      'ja': {
        translation: JAPANESE
      },
      'fr': {
        translation: FRENCH
      },
    }
  }, (err, t) => {
    // console.log('TRANSLATIONS LOADED t', t("location"));
  })
// i18n.changeLanguage(currentLng);

export default i18n
